<template>
  <div class="universal">
    <div
      v-if="!isMobile"
      class="phone"
      :class="{ phone_mobile: isMobile }">
      <div class="phone__wrap">
        <div class="phone__template">
          <div class="template">
            <div ref="tempBody" class="template__body">
              <iframe :src="sourceHtml" ></iframe>
            </div>
          </div>
        </div>
        <img
          src="@/assets/phone.png"
          alt="buzz phone"
          class="phone__img">
      </div>
    </div>
    <div v-else>
      <header class="header">
        <div class="header__cont">
          <div class="header__item">
            <img class="img img_logo" src="/pages/desktop/logo.png" alt="">
          </div>
          <div class="header__item">
            <ul class="menu">
              <li class="menu__item">Новости</li>
              <li class="menu__item">Тест-драйвы</li>
              <li class="menu__item">Фото и видео</li>
            </ul>
          </div>
          <div class="header__item">
            <img class="img img_no-pad img_mob" src="/pages/desktop/burger.png" alt="">
            <img class="img img_no-pad" src="/pages/desktop/search.png" alt="">
          </div>
        </div>
      </header>
      <section class="main">
        <div class="main__cont">
          <div class="main__cont">
            <div class="main__img">
              <img src="/pages/desktop/auto.jpg" alt="" class="img">
            </div>
            <div class="main__block">
              <div class="main__date">12 ИЮЛЯ 2017 15:38</div>
              <div class="main__butt">Новинки</div>
              <div class="main__title">ПРЕДСТАВЛЕНО НОВОЕ ПОКОЛЕНИЕ КУЛЬТОВЫХ ЛОНДОНСКИХ ТАКСИ</div>
            </div>
          </div>
          <div class="main__block2">
            <div class="main__issue">Новое поколение знаменитых лондонских такси представила компания London Taxi Company, которая сейчас входит в состав китайского концерна Geely. Классический черный кэб стал гибридом с увеличенным запасом хода и попутно получил некоторое количество фишек от Volvo.</div>
            <div class="main__desc">Экстерьер такси разрабатывался под контролем главного стилиста концерна Питера Хорбери, который предпочел сохранить кэбу узнаваемую внешность, но при этом заявил, что работать над ней было "так же сложно, как заботиться о драгоценностях шведской короны". По его словам, срок жизни обычного автомобиля, как правило, составляет около семи лет, после чего следует обновление – однако, в случае с кэбом этот срок увеличивается до 15-20 лет, и поэтому главной задачей было добиться того, чтобы внешность такси оставалась актуальной и через два десятка лет.</div>
          </div>
          <div class="main__block3">
            <div class="main__img2">
              <img src="/pages/desktop/auto5.jpg" alt="" class="img">
              <div class="main__link">Московский каршеринг занес беспредельщиков в "черный список"</div>
            </div>
            <div class="main__desc">Британцы планируют построить на территории Лондона к концу следующего года до 300 зарядных станций – специально для таксистов. Кроме того, TX eCity будет экспортироваться и в другие страны Европы: к примеру, 250 кэбов уже заказали Нидерланды. В Лондоне же к 2020 году потребности туристов будут обеспечивать до 9 000 гибридных кэбов.</div>
          </div>
          <div class="main__block2">
            <div class="main__desc">В целом же интерьер кэба по имени TX eCity получил ряд компонентов, которые применяются в интерьерах автомобилей марки Volvo. К примеру, шведское происхождение имеют блок мультимедийной системы, рулевое колесо, рычаг переключения передач и тому подобное.</div>

                  <div style=" margin: 0 auto; padding:0 0 24px 0;text-align: center">
                   <div id="marker"></div>
                  <script type="application/javascript">
                    var marker = document.querySelector("#marker"),
                      container = document.createElement("div"),
                      adn = {},
                      preroll = false,
                      hash = null,
                      env = null;

                    function parseParam(param) {
                      var array = param.split("="),
                        key = array[0],
                        value = array[1];

                      switch (key) {
                        case "hash":
                          hash = value;
                          break;
                        case "preroll":
                          preroll = value === "true";
                          break;
                        case "api":
                          env = value;
                          break;
                        default:
                          value = value.replace(/%(?!\d+?)/g, "%25");
                          var decode = decodeURIComponent(value);
                          try {
                            adn[key] = JSON.parse(decode);
                          } catch (e) {
                            adn[key] = decode;
                          }
                      }
                    }

                    window.location.hash.replace(/^#/, "").split(";").forEach(parseParam);

                    window.bzextenddata = adn;

                    container.className = "buzzplayer-stage";
                    container.dataset.debug = "true";

                    if (env === "dev") container.setAttribute("data-debug_api", "dev");
                    if (!!hash) container.dataset.hash = hash;
                    if (preroll) {
                      if (!adn.unit_settings) adn.unit_settings = {};
                      adn.unit_settings.overroll = true;
                      adn.unit_settings.expandable = false;
                      adn.unit_settings.debug_mode = true;

                      var parent = marker.parentNode,
                        percentWidth = (adn.unit_settings.width || "").indexOf("%") !== -1,
                        percentHeight = (adn.unit_settings.height || "").indexOf("%") !== -1,
                        width, height;

                      function getParam(param, percent) {
                        if (percent || isNaN(parseInt(adn.unit_settings[param], 10))) {
                          var result;
                          if (parent.getBoundingClientRect && (result = parent.getBoundingClientRect()[param]) && !isNaN(result)) {
                            return percent ? result * (parseInt(adn.unit_settings[param], 10) / 100) : result;
                          } else {
                            return parent["client" + param.slice(0, 1).toUpperCase() + param.slice(1)];
                          }
                        } else {
                          return parseInt(adn.unit_settings[param], 10);
                        }
                      }

                      width = getParam("width", percentWidth);
                      if (percentHeight || isNaN(parseInt(adn.unit_settings.height, 10))) {
                        height = width * 9 / 16;
                      } else {
                        height = parseInt(adn.unit_settings.height, 10);
                      }

                      adn.unit_settings_list = null;
                      container.innerHTML = "<div style='width: " + width + "px; height: " + height + "px; background: #000000; color: #FFFFFF; line-height: " + height + "px; text-align: center;'>PLACEMENT PLAYER (PREROLL DEMO)</div>";
                      var wrap = document.createElement("div");
                      wrap.style.width = width + "px";
                      wrap.style.margin = "0 auto";
                      wrap.appendChild(container);
                      container = wrap;
                    }

                    marker.parentNode.insertBefore(container, marker);
                    marker.parentNode.removeChild(marker);
                    </script>
                  </div>

            <div class="main__desc">Благодаря увеличению доли алюминия в конструкции такси удалось сделать легче, просторнее и комфортнее: в пассажирской части салона теперь меньше шума и вибраций. Шестиместный салон получил еще и выдвижную рампу для пассажиров с ограниченными возможностями.</div>
            <img src="/pages/desktop/auto2.jpg" alt="" class="img">
            <div class="main__desc">Силовая установка такси стала гибридной. Электродвигатель, бензиновый турбомотор объемом 1,3 л и набор аккумуляторов обеспечивают кэбу запас хода в 640 км, при этом на электротяге он способен проехать до 110 км. Аккумуляторы можно подзаряжать от стороннего источника энергии: по сведениям издания Autocar, этот процесс займет от 20 минут при использовании особого зарядного устройства до 8 часов от обычной розетки. По словам разработчиков, среднестатистический лондонский таксист сможет экономить на топливе до 100 фунтов (115 евро) в неделю по сравнению с предыдущим дизельным поколением кэба.</div>
            <img src="/pages/desktop/auto3.jpg" alt="" class="img">
            <div class="main__desc">Британцы планируют построить на территории Лондона к концу следующего года до 300 зарядных станций – специально для таксистов. Кроме того, TX eCity будет экспортироваться и в другие страны Европы: к примеру, 250 кэбов уже заказали Нидерланды. В Лондоне же к 2020 году потребности туристов будут обеспечивать до 9 000 гибридных кэбов.</div>
            <img src="/pages/desktop/auto4.jpg" alt="" class="img">
          </div>
        </div>
        <div class="main__bott">
          <div class="main__cont2">
            <div class="info">
              <img src="/pages/desktop/auto6.jpg" alt="" class="img">
              <div class="info__title">Роскошный внедорожник Bentley получит гибридную версию</div>
              <div class="info__desc">Компания Bentley в ближайшее время дополнит гамму модификаций Bentayga гибридной версией, которая сможет передвигаться исключительно на электротяге. Силовую установку позаимствуют у Porsсhe. </div>
            </div>
          </div>
          <div class="main__cont2">
            <div class="info">
              <img src="/pages/desktop/auto7.jpg" alt="" class="img">
              <div class="info__title">Новый BMW X3: названа российская цена</div>
              <div class="info__desc">Компания BMW совсем недавно официально рассекретила третье поколение кроссовера Х3. Теперь же стало известно, сколько будет стоить в России начальная комплектация премиум-паркетника.</div>
            </div>
          </div>
        </div>
      </section>
      <footer class="footer">
        <div class="footer__cont">
          <div class="footer__logo">
            <img class="img img_logo" src="/pages/desktop/logo2.png" alt="">
          </div>
          <ul class="menu menu_foot">
            <li class="menu__item">Новости</li>
            <li class="menu__item">Тест-драйвы</li>
            <li class="menu__item">Фото и видео</li>
          </ul>
        </div>
      </footer>
      <script type="application/javascript" src="/vendor/buzzlibrary.js"></script>
      <script type="application/javascript" src="/vendor/buzzlibrary_extra.js"></script>
    </div>
  </div>
</template>


<script>
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'UniversalMobile',
  props: {
    site: {
      type: String,
    },
  },
  data() {
    return {
      sourceHtml: '/pages/universalMobile/index.html',
      isMobile,
    };
  },
};
</script>

<style scoped lang='stylus'>

body
  margin 0
  padding 0

iframe
  border 0
  width 100%
  height 100.5%
  position absolute
  left 0
  top 0

.universal
  width 100%
  height 100%
  position absolute

.template
  position relative
  height 100%
  width 100%
  background white
  font-size 20px
  line-height normal
  overflow hidden
  font-family Helvetica, sans-serif
  &__body
    position relative
    width 100%
    height 100%
  &__title
    font-size 19px
    line-height 23px
  &__pretitle
    font-size 16px
    line-height 20px
  &__desc
    font-size 14px
    line-height 18px
    text-align left
  &__image
    display block
    width 100%
    height auto
    margin-bottom 20px
  &__header
    position absolute
    left 0
    top 0
    width 100%
    z-index 10
    background white
  &__video
    display block
    width 100%
    height auto

.phone
  width 100%
  height 100%
  text-align center
  display flex
  align-items center
  &_mobile
    margin 0
  &__wrap
    display inline-block
    margin 0 auto
    width auto
    position relative
    ^[0]_mobile &
      width 100vw
      height 100vh
  &__img
    position relative
    width 407px
    height 735px
    z-index 9999
    pointer-events none
  &__template
    position absolute
    left 0
    top 0
    width 100%
    height 100%
    overflow auto
    padding 15% 7% 13% 7%
    box-sizing border-box
    ^[0]_mobile &
      padding 0

m-1280()
  @media all and (max-width: 1280px)
    {block}
m-900()
  @media all and (max-width: 900px)
    {block}
m-670()
  @media all and (max-width: 670px)
    {block}

.img
  width 100%
  height auto
  padding 0 0px 24px 0px
  &_no-pad
    padding 0
    display inline-block
    height 38px
    width auto
    +m-670()
      display none
  &_mob
    display none
    +m-900()
      display inline-block
      margin-right 10px
    +m-670()
      margin 0
  &_logo
    height 15px
    width auto
    padding 0

.header
  width 100%
  background-color rgba(255, 255, 255, .9)
  border-bottom 1px solid #a1a1a1
  position fixed
  top 0
  left 0
  z-index 999
  padding 0
  +m-670()
    position relative
  &__cont
    display flex
    justify-content space-between
    align-items center
    margin 0 auto
    width 100%
    max-width 1104px
    padding 24px
    box-sizing border-box
    +m-670()
      padding 15px 24px 5px
  &__item
    display inline-block

.main
  margin-top 95px
  overflow hidden
  +m-900()
    padding 0 24px
  +m-670()
    margin 0
  &__cont
    margin 0 auto
    width 100%
    max-width 1104px
    padding 12px 0 0
    box-sizing border-box
    font-size 0
    +m-1280()
      width 816px
    +m-900()
      max-width 528px
      width 100%
  &__img
    display inline-block
    width 50%
    +m-900()
      width 100%
  &__img2
    margin 0 24px 24px 0
    width 288px
    float left
    +m-900()
      width 100%
      float none
  &__block
    display inline-block
    width 50%
    position relative
    top -35px
    +m-900()
      width 100%
      top 0
  &__date
    font-weight 300
    font-style normal
    font-size 10px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform uppercase
    text-decoration none
    line-height 10px
    color #ff0147
    display block
    padding 10px 0
    margin 0 0 0 24px
    +m-900()
      margin 0 0 12px
  &__butt
    font-weight 300
    font-style normal
    font-size 10px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform uppercase
    text-decoration none
    line-height 10px
    color #fff
    display inline-block
    padding 10px 18px
    margin 0 0 24px 24px
    background #ff0147
    +m-900()
      margin 0 0 12px
  &__title
    font-weight 300
    font-style normal
    font-size 25px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform uppercase
    text-decoration none
    line-height 37.5px
    color #000
    margin 0 0 0 24px
    +m-900()
      margin 0
      padding 0
    +m-670()
      font-size 18px
      line-height 27px
  &__link
    font-weight 300
    font-style normal
    font-size 16px
    font-family 'Open Sans', Verdana, sans-serif
    text-transform none
    text-decoration underline
    line-height 24px
    color #ff0147
  &__block2
    // width 100%
    // padding 0 0px 24px 0px
    width 696px
    padding 0 312px 24px 144px
    +m-1280()
      // width 456px
      padding 0 312px 24px 120px
    +m-900()
      width 100%
      padding 0 0px 24px 0px
  &__block3
    // width 100%
    // padding 0 0px 24px 0px
    width 696px
    padding 0 312px 24px 0
    +m-900()
      width 100%
      padding 0
  &__issue
    font-weight 600
    font-style normal
    font-size 18px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform none
    text-decoration none
    line-height 27px
    color #565656
    margin 0 auto
    padding-bottom 24px
  &__desc
    font-weight 300
    font-style normal
    font-size 18px
    font-family 'Open Sans', Verdana, sans-serif;
    text-transform none
    text-decoration none
    line-height 27px
    color #565656
    margin 0 auto
    padding-bottom 24px
  &__bott
    margin 0 auto
    width 100%
    max-width 1104px
    padding 12px 0 0
    box-sizing border-box
    font-size 0
    +m-1280()
      width 816px
    +m-900()
      max-width 528px
      width 100%
  &__cont2
    display inline-block
    width 45%
    margin-right 10%
    margin-bottom 5%
    vertical-align top
    &:last-child
      margin-right 0
    +m-670()
      width 100%

.info
  &__title
    font-weight 300
    font-style normal
    font-size 25px
    font-family 'Roboto', Verdana, sans-serif
    text-transform none
    text-decoration none
    line-height 30px
    color #000
    display block
    margin 12px 0 0
  &__desc
    font-weight 400
    font-style normal
    font-size 16px
    font-family 'Open Sans', Verdana, sans-serif
    text-transform none
    text-decoration none
    line-height 24px
    color #565656
    display block
    margin 12px 0 0

.menu
  list-style-type none
  margin 0
  padding 0
  color #000
  +m-900()
    display none
  &_foot
    color white
    margin 18px auto 0
    padding 0 0 17px
    text-align center
    &^[0]__item
      &:hover
        color #ff0147
  &__item
    display inline-block
    padding 14px
    font-size 16px
    line-height 16px
    border none
    outline none
    vertical-align middle
    font-family Roboto, Verdana, sans-serif
    cursor pointer
    border-radius 3px
    transition all .5s
    &:hover
      background #ff0147
      color #fff

.footer
  background-color #252525
  text-align center
  padding 24px
  &__cont
    margin 0 auto
    width 100%
    max-width 1104px
    padding 24px 24px 0
    box-sizing border-box
    border-bottom 1px solid #565656
    +m-900()
      padding 24px
  &__logo
    padding 36px 0 0
</style>
